<template>
    <div class="top-tags">
        <div class="tags-body">
            <p><a href="#" @click="this.$router.push('/')">首页</a> > <a href="#" @click="this.$router.push('/Standard')">评级标准</a></p>
        </div>
    </div>
    <div class="Standard-zhu">
        <h3>银币评级标准</h3>
        <div class="Standard-body">
            <el-table :data="tableData1" border style="width: 100%">
                <el-table-column prop="title" label="级别" width="82px"/>
                <el-table-column prop="content" label="描述" />
            </el-table>

        </div>
        <h3>古币评级标准</h3>
        <div class="Standard-body">
            
            <el-table :data="tableData2" border style="width: 100%">
                <el-table-column label="评级代号代表含义: L (裂.暗裂) B (修补) C (有戳记) D (有洞) S (私铸) Q (不平.有明显的翘) E (有铸造缺陷) F (表面严重腐蚀) ">
                    <el-table-column prop="title" label="级别" width="87px"/>
                    <el-table-column prop="content" label="描述" />
                </el-table-column>
            </el-table>

        </div>
		<h3>责任与赔偿</h3>
		<div class="Standard-body">
			<p>一、本公司对所有客户寄到、送到的钱币负有保管责任。如签收后发生丢失、损坏，均由公司负责。签收前发生在邮寄过程中的丢失和损坏，不在本公司责任范围内。寄回客户过程中发生的丢失、损坏，由寄送公司负责赔偿解决，本公司负查询、协助责任。客户签收后该邮件不再与本公司有关。</p>
			<br>
			<p>二、本公司对于鉴定为赝品的钱币按照真币收费标准收费。如果对评级结果有任何疑问 可以发回复评，复评和第一次结果相同时需要再次支付相对应的费用，如果复评结果不同则免去复评费用。并且赔付第一次鉴定费用。</p>
			<br>
			<p>三、客户对有异议的本公司评级币（有政泉评级唯一编号并且有官网图）仅支持本公司复检，如果复检结果不同，本公司会按照市场价值进行赔付。赔付完成后此币归本公司所有。赔付金额依据交易记录和市场价作共同依据,对于虚假提供交易记录，恶意索赔用户本公司有权拒绝赔偿，交易过程中产生的溢价本公司不作任何赔付。</p>
			<br>
			<p>四、本公司赔付对象为政泉评级入盒且评级封装盒子完整 ,无明显损坏的所有品种的评级币。</p>
			<br>
			<p>五、关于版别标注，以及钱币性质的赔付标准，本公司赔付标准以本公司实际标注为赔偿依据，如并未对此币进行版别标注以及性质标注，客户自认为以名誉版别，或者有性质的钱币价格进行购买，如有问题则按照普通版本赔偿。</p>
			<br>
			<p>六、每枚钱币只进行一次性赔付 ，赔付完整此币归本公司所有，因钱币买卖所产生的佣金和溢价均不在我们赔付范围之内。</p>
			<br>
			<p>七、对于政泉评级币有疑问的客户请第一时间联系本公司并且发回本公司复评。私自砸盒者将不享受本公司赔付原则。</p>
			<br>
			<p>八、对于钱币明显修补及裂纹等瑕疵没有标注的，一旦确认将根据市场价值赔付，赔付完成后此币归本公司所有。</p>
			<br>
			<p>九、对于本公司包装上标注为现代、私铸以及部分邻国币，因各评级公司封装政策不同，导致其他公司不能装盒的，不做为赔付依据。</p>
		</div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            tableData1: [
                {
                    title: 'FR-2X',
                    content: '可以看出一些细节，但部分磨损',
                },
                {
                    title: 'AG-3',
                    content: '几乎所有部分已接近磨平，有时只能辨别出年代',
                },
                {
                    title: 'G-4',
                    content: '佳品，磨损严重，只能分辨出主要图像',
                },
                {
                    title: 'G-6',
                    content: '边缘完整细节平坦，币周边的字体完整',
                },
                {
                    title: 'VG-8',
                    content: '	图案磨损但有少量细节',
                },
                {
                    title: 'VG-10',
                    content: '图案磨损但有少量细节是稍微清晰的',
                },
                {
                    title: 'F-12',
                    content: '一些深打的嵌入的地方有细节，所有字体明晰',
                },
                {
                    title: 'F-15',
                    content: '深打嵌入的地方稍微多一些细节，所有字体明晰',
                },
                {
                    title: 'VF-20',
                    content: '有一些清晰的细节，所有字体饱满清晰',
                },
                {
                    title: 'VF-25',
                    content: '细节和字体清晰',
                },
                {
                    title: 'VF-30',
                    content: '在凸起的地方有磨损',
                },
                {
                    title: 'VF-35',
                    content: '细节完整但凸起磨损平坦的地方完整',
                },
                {
                    title: 'VF-40',
                    content: '细节完整但大部分高点轻微磨损平坦',
                },
                {
                    title: 'VF-45',
                    content: '细节完整但有一些凸起部分磨损',
                },
                {
                    title: 'AU-50',
                    content: '未流通币面凸起部分有不同程度磨损痕迹，有一半以上币面保持原有光泽',
                },
                {
                    title: 'AU-53',
                    content: '细节完整，一半以上的表面有摩擦损伤，高点有非常轻微的平坦',
                },
                {
                    title: 'AU-55',
                    content: '即精选近于未流通，仅在币面凸起部分有轻微磨损痕迹',
                },
                {
                    title: 'AU-58',
                    content: '所有细节完整，只有高点处有摩擦损伤',
                },
                {
                    title: 'MS-60',
                    content: '即标准未流通，有一定的划痕疵病，边缘也有少量磕碰，光亮或本色',
                },
                {
                    title: 'MS-61',
                    content: '没有磨损，有许多很严重的刮丝和划痕，（币的图案）可以不完全打印出来',
                },
                {
                    title: 'MS-62',
                    content: '没有磨损，轻微的较少的刮丝和划痕，压印可能不完整',
                },
                {
                    title: 'MS-63',
                    content: '细小的刮丝和划痕，压印可能不完整',
                },
                {
                    title: 'MS-64',
                    content: '刮丝和划痕很少，或者两面中的某一面有比较严重划痕',
                },
                {
                    title: 'MS-65',
                    content: '即精选精制，用4倍放大镜可见轻微划痕或缺陷，一般说来已经很完美',
                },
                {
                    title: 'MS-66',
                    content: '在不重要的地方有很少量的刮丝和划痕，未流通',
                },
                {
                    title: 'MS-67',
                    content: '完美未流通，币完好只有微少的瑕疵',
                },
                {
                    title: 'MS-68',
                    content: '完美未流通，只有微不足道的瑕疵，币面光泽',
                },
                {
                    title: 'MS-69',
                    content: '只有极其微少的瑕疵，更重要的是接近完美，未流通',
                },
                {
                    title: 'MS-70',
                    content: '属普制币中的最佳状态，用4倍放大镜可发现一些疵病。由于币面光泽的差异又分为光亮完美未流通和本色完美未流通',
                },

            ],
            tableData2: [
                {
                    title: '上品40-49',
                    content: '文字可以识别但边道不完整或有轻微或严重腐蚀，并且锈色不够完美。',
                },
                {
                    title: '上品50-59',
                    content: '文字可以识别细节完整，但字口不够深峻，锈色过重，或包浆不够完美。边道有少许缺陷。',
                },
                {
                    title: '美品60-69',
                    content: '字口清晣，边道完整，穿口规整，没有明显腐蚀和铸造缺陷。并且没有明显的人为清理。',
                },
                {
                    title: '美品70-79',
                    content: '字口深峻，边道完整，锈色相对完美，几乎没有腐蚀和铸造缺陷。并且边道几乎没有缺陷。',
                },
                {
                    title: '极品80-100',
                    content: '字口深峻，边道完整，穿口规整，没有腐蚀和铸造缺陷，锈色完美。',
                },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
//-------------------------------小跳转菜单
.top-tags {
    width: 100%;
    height: 40px;
    background: #f3f3f3;
    .tags-body {
        width: 1210px;
        margin: 0 auto;
        border: 1px solid #f3f3f3;
        text-align: left;
        position: relative;
        @media only screen and (max-width: 1225px) {
            width: 100%;
        }
        
        p {
            margin-top: 10px;
            padding-left: 5px;
            border-left: 6px solid #409EFF;
            
            a {
                color: #303133;
                font-size: 14px;
                text-decoration: none;
                &:hover {
                    color: #409EFF;
                }
            }
        }
    }
}

.Standard-zhu {
    width: 1400px;
    margin: 0 auto;
    @media only screen and (max-width: 1400px) {
        width: 100%;
    }
    h3 {
        @media only screen and (max-width: 810px) {
            width: 90%;
            margin: 20px 5%;
        }
        font-size: 24px;
        text-align: left;
        margin: 20px 96px;
        padding: 10px 0;
        border-bottom: 1px solid #DFDFDF;
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 48px;
            bottom: -1px;
            width: 100px;
            height: 2px;
            margin-left: -50px;
            background-color: #409EFF;
        }
    }
    .Standard-body {
        padding-left: 94px;
        @media only screen and (max-width: 1300px) {
            padding: 0 4%;
        }
        @media only screen and (max-width: 735px) {
            padding: 0 1%;
        }
		p {
			font-size: 15px;
			line-height: 25px;
			text-align: justify;
			margin: 0 auto;
			margin-right: 15px;
			@media only screen and (max-width: 1250px) {
				margin-left: 15%;
			}
		
			@media only screen and (max-width: 1200px) {
				margin-left: 10%;
			}
		
			@media only screen and (max-width: 980px) {
				word-break: break-all;
				word-wrap: break-word;
				width: 95%;
				margin-left: 2.5%;
			}
			// @media only screen and (max-width: 580px) {
			// 	word-break: break-all;
			// 	word-wrap: break-word;
			// 	width: 90%;
			// 	margin-left: 0%;
			// }
		}
    }
}
</style>